import styled from 'styled-components';

// Container flat: sem cards aninhados. A Section externa (em aplicacao.js)
// ja prove o padding do shell; aqui dentro e so estrutura de layout.
// Sem height fixa + overflow visivel pra deixar o LeftColumnGrid pai
// (overflow-y auto) cuidar do scroll. Antes height 100% + overflow
// hidden cortava o final do conteudo (a grid de Ontime/Total/Rendimento
// ficava clipada e o scroll do form nao alcancava).
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  padding: 0;
  gap: 18px;
  min-height: 0;
`;

// Abas do detalhe operacional: "Detalhes operacionais" (medicoes/carrossel)
// e "Log" (eventos que tiraram a maquina do normal). Estilo pill/chip
// (mesmo formato do SectionTag) — a aba ativa ganha fill + borda em tom
// de tinta; inativas ficam outline mute. Tokens CCO.
export const Tabs = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const Tab = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  font-family: inherit;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  padding: 7px 14px;
  border-radius: 999px;
  transition: color 120ms, background 120ms, border-color 120ms;

  ${(props) => {
    const line = (props.$accent && props.$accent.line) || 'var(--cco-line-strong)';
    const soft = (props.$accent && props.$accent.soft) || 'var(--cco-soft-surface)';
    return props.$active
      ? `
        background: ${soft};
        border: 1px solid ${line};
        color: ${line};
      `
      : `
        background: transparent;
        border: 1px solid var(--cco-line);
        color: var(--cco-ink-faint);
      `;
  }}

  svg {
    flex-shrink: 0;
  }

  &:hover {
    color: ${(props) =>
      (props.$accent && props.$accent.line) || 'var(--cco-ink)'};
    border-color: ${(props) =>
      (props.$accent && props.$accent.line) || 'var(--cco-line-strong)'};
  }
`;

// StatusCard agora e um strip simples (sem borda nem sombra). Os pills
// internos da OperationalStatus ja sao indicadores visuais coloridos —
// nao precisam de wrapper card.
//
// nowrap + 5 pares com flex:1 dentro da OperationalStatus distribuem
// igualmente a largura do row. Em colunas largas crescem ate preencher;
// em colunas estreitas encolhem (com ellipsis nos labels). Sem
// overflow horizontal — os pills se adaptam.
export const StatusCard = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 6px;
  box-sizing: border-box;
  width: 100%;
  min-height: 0;
  flex-shrink: 0;

  ${(props) =>
    props.empty
      ? 'height: 0;'
      : `
        padding: 6px 4px 18px;
        border-bottom: 1px solid ${props.theme.colors.disabled};
      `}
`;

// ConfigCard agora e a area de conteudo principal (header + carrossel),
// sem borda propria — a Section pai ja envelopa. gap interno separa
// HeaderBar (MAQUINA X DE Y) do carrossel (imagem + medicoes).
// Sem height fixa / flex 1 — sizing natural pra o LeftColumnGrid pai
// (overflow-y auto) scrollar a grid de medicoes quando passa do viewport.
export const ConfigCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  gap: 20px;
`;

// Cabecalho do carrossel — info da maquina + botao Operacional.
// Layout horizontal flat, sem peso visual proprio (a Section ja prove
// o card visual).
export const HeaderBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-shrink: 0;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
`;

export const MachineCount = styled.span`
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: ${(props) => props.theme.colors.label};
  opacity: 0.75;
  flex-shrink: 0;
`;

export const MachineName = styled.h2`
  font-size: 15px;
  font-weight: 800;
  margin: 0;
  color: ${(props) => props.theme.colors.darkerblue};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;

  small {
    font-size: 11px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.label};
    margin-left: 6px;
  }
`;

export const ClosedCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  text-align: center;
  margin: 0 auto;
  transition: transform 300ms;
  transform: scale(0.8);
  padding: 20px 0;
  width: 270px;

  @media (min-width: 1400px) {
    padding: 5px 0;
  }

  border: ${(props) =>
    props.active &&
    `1px solid ${props.theme.colors.blue}; border-radius: 8px`};
  ${(props) =>
    props.active
      ? `animation: card-scale-animation-in;
      animation-duration: 300ms;
      transform: scale(1.05, 1.05);`
      : `animation: card-scale-animation-in;
      animation-delay: 0ms;
      animation-duration: 300ms;
      `};

  h2 {
    font-size: 18px;
    color: ${(props) => props.theme.colors.blue};
  }
  h3 {
    font-size: 16px;
    color: ${(props) => props.theme.colors.lightblue};
  }
  h4 {
    font-size: 12px;
    color: ${(props) => props.theme.colors.darkerblue};
  }
  span {
    font-size: 12px;
    font-weight: 900;
    color: ${(props) => props.theme.colors.darkerblue};
    padding: 10px 25px;
    box-shadow: none;
  }
  img {
    cursor: pointer;
  }

  @keyframes card-scale-animation-in {
    from {
      transform: scale(0.8);
    }
    to {
      transform: scale(1.05, 1.05);
    }
  }

  @keyframes card-scale-animation-out {
    from {
      transform: scale(1.05, 1.05);
    }
    to {
      transform: scale(0.8);
    }
  }
`;

// Grid de medicoes 3x2. Gap generoso (row > column) — separacao
// vertical entre as duas linhas de metricas e o que define o ritmo
// visual da grid. Auto rows sizing natural (sem flex 1) pra o
// LeftColumnGrid pai cuidar do scroll quando passa.
export const CardWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto auto;
  gap: 26px 18px;
  /* padding bottom evita que o overflow:hidden do react-multi-carousel
     (na track .react-multi-carousel-list) corte a linha inferior dos
     ValueWrapper da ultima linha de cells. Sem isso, o border-bottom
     dos cards na 2a row ficava clipped contra a borda do slide. */
  padding-bottom: 8px;
  box-sizing: border-box;
`;

export const TitleLine = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  left: 5px;
  right: 5px;
  top: 5px;
  margin-bottom: 20px;

  h5 {
    font-size: 15px;
    color: ${(props) => props.theme.colors.darkblue};
  }

  h4 {
    margin: 0 auto;
    font-size: 18px;
    span {
      color: ${(props) => props.theme.colors.lightblue};
      font-size: 18px;
    }
  }

  button {
    z-index: 1;
  }
`;

export const TitleLineBox = styled.div`
display: flex;
align-items: center;
`

// Container interno do carrossel: imagem (Cell) + grid de medicoes
// (CardWrapper). gap maior pra separar visualmente a imagem das
// medicoes abaixo. Sizing natural pra o scroll do form lidar com
// o conteudo extenso.
export const CardWrapperContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  width: 100%;
`;

export const Cell = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.row ? 'row' : 'column')};
  align-items: center;
  justify-content: ${(props) =>
    props.left ? 'flex-end' : props.right ? 'flex-start' : 'center'};
  /* gap entre label e valor — antes label colava no valor.
     row layout (imagem) nao precisa de gap, so column. */
  ${(props) => !props.row && 'gap: 6px;'}
  border-radius: 10px;
  font-weight: 800;
  position: relative;
  ${(props) =>
    props.imagem &&
    `background-image: url(${props.imagem}); background-size: 100% 100%; `}

  h2 {
    color: ${(props) => props.theme.colors.blue};
    font-size: clamp(28px, 5.5vw, 50px);
    font-weight: 100;
    transform: scale(0.8, 1.7);
    cursor: inherit;
  }

  h3 {
    font-size: 20px;
    color: ${(props) =>
      props.gradient
        ? props.theme.colors.white
        : props.theme.colors.darkerblue};
    margin-bottom: 4px;
    cursor: inherit;
  }

  label {
    font-size: 16px;
    color: ${(props) =>
      props.gradient
        ? props.theme.colors.white
        : props.theme.colors.darkerblue};
    cursor: inherit;
  }

  img {
    cursor: pointer;
  }
`;

// Label das medicoes — peso/cor muted pra nao competir com o valor.
// Antes era weight:700 + cor label cheia, o que invertia a hierarquia
// visual (label dominava o valor). Agora weight:500 + opacidade 0.7
// deixa o valor (verde, weight 700) como heroi do bloco.
export const Text = styled.label`
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  text-align: center;
  color: ${(props) => props.theme.colors.label};
  opacity: 0.7;
  padding: ${(props) => props.padding || '0'};
  line-height: 1;
`;

// ValueWrapper em estilo card — mesmo padrao do 'Acumulado historico'
// (visao-geral-uchas-ebas): border-radius 16px, border 1px sutil,
// box-shadow leve. Da destaque ao valor sem ser pesado visualmente.
export const ValueWrapper = styled.div`
  color: ${(props) => props.theme.colors.green};
  width: ${(props) => (props.half ? '45%' : '92%')};
  text-align: center;
  font-size: clamp(14px, 1.2vw, 18px);
  font-weight: 700;
  padding: 10px 0;
  margin-bottom: 0;
  position: relative;
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.colors.disabled};
  box-shadow: none;
  ${(props) => props.clickable && `cursor: pointer;`}
`;

export const PolygonWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.toRight ? props.theme.colors.blue : props.theme.colors.green};
  align-self: ${(props) => (props.left ? 'flex-end' : 'flex-start')};
  border-radius: 6px;
  height: 63px;
  width: 70%;
  margin-bottom: 9px;
  font-size: 50px;

  ${(props) => props.left && `margin-right: -13px;`}
  ${(props) => props.right && `margin-left: -10px;`}

  label {
    text-align: center;
    position: absolute;
    top: 18px;
    ${(props) => props.left && 'right: 0px;'}
    ${(props) => props.right && 'left: 0px;'}
    font-size: 13px;
  }
`;

export const Button = styled.div`
  text-align: center;
  background: transparent;
  color: ${(props) => props.theme.colors.lightblue};
  border: 1px solid ${(props) => props.theme.colors.lightblue};
  border-radius: 10px;
  :hover {
    background: ${(props) => props.theme.colors.lightblue};
    color: ${(props) => props.theme.colors.white};
  }
`;

export const Arrow = styled.img`
  height: clamp(30px, 4vw, 50px);
  ${(props) => props.left && 'transform: scaleX(-1);'}
`;

export const Image = styled.img`
  height: clamp(70px, 9vw, 110px);
  max-width: 100%;
  object-fit: contain;
  ${(props) => props.flip && 'transform: scaleX(-1);'}
`;

// Palco da imagem da BLUEBOX: wrapper posicionado pra sobrepor a linha de
// nivel. Usado so pra bluebox (imagem que inclina pela variavel Tilt).
export const TiltStage = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Largura responsiva; a ALTURA vem do aspect-ratio calculado pelo grau
     de inclinacao (inline no JSX) — quase plano em angulos pequenos, mais
     alto em 45/90, sem espaco vertical desnecessario nem corte. */
  width: clamp(220px, 26vw, 340px);
  min-height: 84px;
  overflow: visible;

  /* Imagem ocupa a largura do palco (sobrescreve a altura fixa do Image
     base) e mantem proporcao; rotaciona por cima via transform. */
  > img {
    width: 100%;
    height: auto;
    max-width: 100%;
    object-fit: contain;
  }
`;

// Linha de nivel (horizontal FIXA) no centro da imagem — referencia pra
// leitura da inclinacao: a peca gira pelo Tilt e o angulo contra esta
// linha fica evidente. Branca semitransparente com leve contorno escuro
// pra contrastar tanto no azul quanto no fundo.
export const TiltLevelLine = styled.span`
  position: absolute;
  left: -8%;
  right: -8%;
  top: 50%;
  height: 2px;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.55);
  box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.45);
  border-radius: 2px;
  pointer-events: none;
`;

// Selo (tooltip fixo) no meio da linha de nivel expondo a variavel
// Inclinacao e o valor em graus — leitura imediata sem hover. Caret
// apontando pra linha. pointer-events none pra nao bloquear o click do
// card (que navega pro Operacional).
export const TiltBadge = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, calc(-100% - 9px));
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.82);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.02em;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  pointer-events: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -4px;
    transform: translateX(-50%) rotate(45deg);
    width: 7px;
    height: 7px;
    background: rgba(0, 0, 0, 0.82);
    border-right: 1px solid rgba(255, 255, 255, 0.25);
    border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  }
`;

// Indicador de bateria estilo mobile/Tesla — abaixo da imagem da bluebox.
// Casca + terminal (nub) + fill proporcional ao Batt (%). Cor por nivel.
export const BatteryWrap = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: -4px;
`;

export const BatteryShell = styled.div`
  position: relative;
  width: 48px;
  height: 21px;
  border-radius: 5px;
  border: 2px solid var(--cco-ink-faint);
  padding: 2px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  &::after {
    content: '';
    position: absolute;
    right: -5px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 8px;
    border-radius: 0 2px 2px 0;
    background: var(--cco-ink-faint);
  }
`;

export const BatteryFill = styled.div`
  height: 100%;
  border-radius: 2px;
  background: ${(props) => props.$color};
  width: ${(props) => props.$pct}%;
  min-width: ${(props) => (props.$pct > 0 ? '3px' : '0')};
  transition: width 400ms ease, background 300ms ease;
`;

export const BatteryLabel = styled.span`
  font-size: 13px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: var(--cco-ink);
`;

export const FlipIcon = styled.img`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  padding: 5px;
  background: ${(props) => props.theme.colors.darkblue};
  position: absolute;
  right: 5px;
  opacity: 0.7;

  :hover {
    opacity: 1;
  }
`;

export const Tag = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 7px;
  margin: 0 10px;
  color: ${(props) => props.color ? props.color: "red"};
  border-radius: 10px;
  border: 1px solid;
  border-color: ${(props) => props.color};
  transition: background-color 0.2s;
  text-transform: ${(props) => props.transform || 'uppercase'};
  // color: ${(props) => props.theme.colors.white};
  font-weight: bold;
  font-size: 12px;
  @media (max-width: 1450px) {
    padding: 4px 10px;
  }
`;
